import { Swiper as SwiperType } from "swiper/types";
import { useEffect, useState } from "react";
import { PostHogCustomEvent, usePostHog } from "./usePostHog";

export const useSwiperScroll = () => {
  const { trackPostHogEvent } = usePostHog();
  const [scroll, setScroll] = useState({
    isScrollOpen: true,
    isEnd: false,
    isBeginning: true,
  });
  const [swiper, setSwiper] = useState<SwiperType | null>(null);

  // Handle Swiper initialization and cleanup
  useEffect(() => {
    if (swiper && !swiper.destroyed) {
      const updateScrollState = (s: SwiperType) => {
        setScroll({
          isBeginning: s.isBeginning,
          isEnd: s.isEnd,
          isScrollOpen: !(s.isBeginning && s.isEnd),
        });
      };

      // Initial check
      updateScrollState(swiper);

      // Add resize listener
      swiper.on("resize", updateScrollState);
      swiper.on("scrollbarDragMove", updateScrollState);
      // This is needed to catch cases where the last scroll from a button press is really small
      // but still takes you to the end of the carousel ... it ensures isBeginning and isEnd are updated
      // It also means we don't need the slideChange event listener
      swiper.on("transitionEnd", updateScrollState);

      // Cleanup
      return () => {
        swiper.off("resize");
        swiper.off("scrollbarDragMove");
        swiper.off("transitionEnd");
      };
    }
  }, [swiper]);

  const handleNextClick = (postHogEventName?: PostHogCustomEvent) => {
    swiper?.slideNext();
    if (postHogEventName) trackPostHogEvent(postHogEventName);
  };

  const handlePrevClick = (postHogEventName?: PostHogCustomEvent) => {
    swiper?.slidePrev();
    if (postHogEventName) trackPostHogEvent(postHogEventName);
  };

  return { scroll, swiper, setSwiper, handleNextClick, handlePrevClick };
};
